<template>
  <div>
    <ok-cancel-close-modal
      :title="$t('health.integration.manageIntegration')"
      :ok-button="$t('health.integration.reIntegrate')"
      :cancel-button="$t('health.integration.removeIntegration')"
      v-on:ok="$emit('integrate')"
      v-on:cancel="$emit('remove')"
      v-on:close="$emit('close')"
    >
      <div
        slot="body">
        <div
          class="margin-top-xl food-list">
          <h3
            class="margin-bottom-l">
            {{ $t('health.integration.integrationModalText', {platform: platform}) }}
          </h3>
        </div>
      </div>
    </ok-cancel-close-modal>
  </div>
</template>

<script>

import OkCancelCloseModal from '@/components/shared/dialogs/OkCancelCloseModal';
export default {
  name: 'IntegrationActionModal',
  components: {
    OkCancelCloseModal
  },
  props: {
    platform: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/integration/IntegrationActionModal.vue